import {useAppStore} from '../appStore'

export const initiativesActions = {
  useResetInitiatives: () => useAppStore(s => s.resetInitiatives),
  useAbortRequest: () => useAppStore(s => s.abortRequest),
  useSetSelectedFilters: () => useAppStore(s => s.setSelectedFilters),
} as const
